var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23C16.2417 23 17.249 21.9928 17.249 20.75H12.7511C12.7511 21.9928 13.7583 23 15 23ZM22.5723 17.7368C21.8931 17.0069 20.6222 15.909 20.6222 12.3125C20.6222 9.58086 18.7069 7.39414 16.1243 6.85766V6.125C16.1243 5.50379 15.6209 5 15 5C14.3792 5 13.8757 5.50379 13.8757 6.125V6.85766C11.2931 7.39414 9.37784 9.58086 9.37784 12.3125C9.37784 15.909 8.10694 17.0069 7.42772 17.7368C7.21678 17.9635 7.12327 18.2346 7.12502 18.5C7.12889 19.0766 7.58135 19.625 8.25354 19.625H21.7465C22.4187 19.625 22.8715 19.0766 22.875 18.5C22.8768 18.2346 22.7833 17.9632 22.5723 17.7368Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.4846475f1a0ed0dd2870521e3b6ea21a.svg";
export { ForwardRef as ReactComponent };